import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import auth from '../../auth/auth';

const ProtectedRoute = ({ component: Component, requiredEntidad, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      // Permitir acceso si es Entidad O si es Gestor
      if (requiredEntidad && !auth.isEntidadUser() && !auth.isGestor()) {
        return <Redirect to="/formencomienda" />;
      }
      return <Component {...props} />;
    }}
  />
);

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/components/ProtectedRoute/ProtectedRoute.js